import { CURRENCY_CODE_MAP } from "@/data/constants";

const ISO_CODE = /^[A-Z]{3}$/;

// The ISO 4217 code for a currency sent as either a code or a symbol;
// `undefined` when unrecognised, so callers decide how to fall back.
export const toCurrencyCode = (currency?: string): string | undefined => {
  if (!currency) return undefined;

  const trimmed = currency.trim();

  if (!trimmed) return undefined;

  const upper = trimmed.toUpperCase();

  if (ISO_CODE.test(upper)) return upper;

  return CURRENCY_CODE_MAP[trimmed];
};
